import { GiftCardOrderExtendedParams, GiftCardOrderParams } from 'types';

import { get, post } from './axios';

const URLS = {
  getGiftCardStyles: 'ecomm-gc-styles',
  getRecipientEmails: 'ecomm-recipient-emails',
  addGiftCardOrder: 'ecomm-order-add-gc',
  getAvailPromo: 'ecomm-gc-avail-promo',
  createOrder: 'ecomm-create-order',
  updateOrder: 'ecomm-update-order',
  getOrder: 'ecomm-get-order',
  orderCheckout: 'ecomm-order-checkout',
  removeGiftCardFormOrder: 'ecomm-order-del-gc',
  getGiftCardPdf: 'ecomm-order-get-sample-pdf'
};

const giftCardsApi = {
  getGiftCardStyles: () => get(URLS.getGiftCardStyles),
  getRecipientEmails: () => get(URLS.getRecipientEmails),
  getAvailGPromo: () => get(URLS.getAvailPromo),
  addGiftCardOrder: (params: GiftCardOrderParams) =>
    post(URLS.addGiftCardOrder, params),
  createOrder: () => post(URLS.createOrder),
  getOrder: (orderId: number) => get(URLS.getOrder, { orderid: orderId }),
  updateOrder: (params: GiftCardOrderExtendedParams) =>
    post(URLS.updateOrder, params),
  orderCheckout: (params: { orderid: number; cc_ott_token?: string }) =>
    post(URLS.orderCheckout, params),
  removeGiftCard: (params: { orderid: number; orderitemid: number }) =>
    post(URLS.removeGiftCardFormOrder, params),
  getGiftCardPdf: (params: { orderid: number; orderitemid: number }) =>
    post(URLS.getGiftCardPdf, params)
};

export default giftCardsApi;
